import React, { useState } from 'react'
import { GrInstagram } from "react-icons/gr";
import { BsYoutube } from "react-icons/bs";
import { AiFillTikTok } from "react-icons/ai";
import { FaSquareFacebook } from "react-icons/fa6";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { HiOutlineMail } from "react-icons/hi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import { FormattedMessage } from 'react-intl';
import { FaTiktok } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { formatFollowers } from '../../utils';
import { IoPersonOutline } from 'react-icons/io5';
import { CATEGORIES } from '../../constants';
import WishList from './WishList';
import ToolTipText from '../../components/ToolTipText';


const Card = ({ item, refreshListing }) => {
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()



    return (
        <>
            {/* bg-[#F2F5EF] */}
            <div onClick={(e) => { e.stopPropagation(); navigate(`/influencer/${item.id}`, { state: { from: "favorite-influencers" } }) }} className='w-[280px] min-h-[400px] p-4 bg-white hover:scale-[1.04] hover:transition-all hover:cursor-pointer duration-75   border-[0.5px] border-gray-200 rounded-xl shadow-lg relative  '>
                {/* <div class="bg-white p-5 rounded-lg"> */}
                <div className='h-[270px] mb-3 flex items-center justify-center rounded-lg shadow-lg bg-cover bg-center bg-no-repeat'
                    style={{
                        backgroundImage: `url(${item?.user?.picture})`
                    }}
                >
                    {
                        !item?.user?.picture &&
                        <IoPersonOutline className='text-5xl text-center text-primary' />
                    }
                </div>
                {/* <div className='absolute bottom-3 right-5'>
                    <WishList refreshListing={refreshListing} id={item.id} />
                </div> */}
                {/* <img class="mb-3   rounded-lg shadow-lg" src={item.image} alt="Bonnie image" /> */}
                <div className='flex justify-between items-center w-full '>
                    <div className='w-[70%]'>
                        <h5 class="mb-1 text-gray-900 flex  !line-clamp-1 space-x-2 items-center ">
                            <ToolTipText value={item?.user?.name  + " " + item?.user?.sur_name} />
                            {/* <RiVerifiedBadgeFill className='text-xl' />  */}
                        </h5>
                        <p className="text-xs text-gray-500">
                            {item?.user?.city}
                            {item?.user?.country ? `, ${item?.user?.country}` : ""}
                        </p>

                    </div>
                    <div className='flex-shrink-0' >
                        {
                            item?.instagram_followers > 0 &&
                            <div className='inline-flex space-x-1 items-center'>
                                <GrInstagram className='text-sm text-gray-500' />
                                <span>{formatFollowers(item?.instagram_followers)}</span>
                            </div>
                        }
                        {
                            item?.tiktok_followers > 0 &&
                            <div>
                                <div className='inline-flex space-x-1 items-center'>
                                    <FaTiktok className='text-sm text-gray-500' />
                                    <span>{formatFollowers(item?.tiktok_followers)}</span>
                                </div>
                            </div>
                        }
                        {
                            item?.instagram_followers === 0 && item?.tiktok_followers === 0 &&
                            <div className='inline-flex space-x-1 items-center'>
                                <GrInstagram className='text-sm text-gray-500' />
                                <span>0</span>
                            </div>
                        }
                        <div className='text-xs  text-gray-500'>Followers</div>
                    </div>
                </div>
                <hr className='h-[2px] border-gray-300 my-3' />

                <div className='flex justify-between items-center'>
                    {/* <div className='flex space-x-2'>
                        <div className='border-[1px] p-1 rounded-lg border-gray-200'>
                            <BsYoutube className='text-lg text-gray-500' />
                        </div>
                        <div className='border-[1px] p-1 rounded-lg border-gray-200'>
                            <AiFillTikTok className='text-lg text-gray-500' />
                        </div>
                        <div className='border-[1px] p-1 rounded-lg border-gray-200'>
                            <FaSquareFacebook className='text-lg text-gray-500' />
                        </div>
                    </div> */}
                    <div>
                        {item?.niches && item?.niches?.length > 0 && (
                            <div className="flex flex-wrap gap-2">
                                {item?.niches.slice(0, 2).map((niche, index) => (
                                    <span
                                        key={index}
                                        className="rounded-full text-xs text-white bg-secondary py-1 px-3"
                                    >
                                        {CATEGORIES.find((item) => item?.value === niche)?.label ? CATEGORIES.find((item) => item?.value === niche)?.label : niche}
                                    </span>
                                ))}
                                {item?.niches?.length > 2 && (
                                    <span className="rounded-full text-xs text-white bg-secondary py-1 px-3">
                                        +{item?.niches?.length - 2}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>


                </div>
                {/* <div className='flex justify-between my-3 items-center'>
                    <div className='text-xs text-gray-500'>
                        Advertising Price
                    </div>
                    <div className='font-bold text-2xl'>
                        $5200
                    </div>
                </div> */}
                {/* <div className='flex items-center space-x-4'>
                    <div className='flex space-x-3'>
                        <div className='border-[1px] p-1 rounded-lg border-gray-200'>
                            <HiOutlineMail className='text-lg text-gray-500' />
                        </div>
                        <div className='border-[1px] p-1 rounded-lg border-gray-200'>
                            <FaCheck className='text-lg text-gray-500' />
                        </div>
                        <div className='border-[1px] p-1 rounded-lg border-gray-200'>
                            <MdOutlineDeleteOutline className='text-lg text-gray-500' />
                        </div>
                    </div>

                    <button className={`py-2 w-full text-xs ${item.is_active?"bg-[#D3F36B]":"bg-red-400/70 text-white"}  px-4 rounded-md`}>{item.is_active?"Active":"Disabled"}</button>
                </div> */}
                {/* </div> */}
            </div>
        </>
    )
}

export default Card